import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import QuickActionButton from '../QuickActionButton/index.js';
import useConfirmation from '../../hooks/useConfirmation/index.js';
import { genericMemo } from '../../utils/index.js';

// eslint-disable-next-line
function QuickActionConfirmButton(props) {
  const {
    confirmButtonActions,
    confirmButtonClassName,
    confirmButtonContent,
    confirmButtonIcons,
    confirmModalProps,
    denyButtonActions,
    denyButtonClassName,
    denyButtonContent,
    denyButtonIcons,
    heading,
    message,
    onConfirm,
    onDeny,
    onResolve,
    showConfirmationInitially,
    ...buttonProps
  } = props;
  const [modal, onButtonClick] = useConfirmation({
    showConfirmationInitially,
    onConfirm,
    onDeny,
    onResolve,
    heading,
    message,
    denyButtonActions,
    denyButtonContent,
    denyButtonIcons,
    denyButtonClassName,
    confirmButtonActions,
    confirmButtonContent,
    confirmButtonIcons,
    confirmButtonClassName
  }, confirmModalProps);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(QuickActionButton, _extends({}, buttonProps, {
    name: undefined,
    onClick: onButtonClick
  })), modal);
}

var index = genericMemo(QuickActionConfirmButton);

export { index as default };
//# sourceMappingURL=index.js.map
